<template lang="pug">
.candidatos-supporter
  label SUPPORTER DO PORTAL
  p.msg.vazio(v-if="!candidatos.length") Nenhum supporter com este nome no portal. O cadastro de supporter vem antes e não é desta tela; se souber o nome certo, busque abaixo.
  small(v-else) Pelo nome que a V.tal informa. Há homônimos: confira e-mail e CPF antes de confirmar.
  button.candidato(type="button" v-for="c in candidatos" :key="c.id_doutor" :class="{ sel: escolhidoE(c), impedido: c.permite_vinculo === false }" @click="$emit('input', c)")
    b {{ c.nome }}
    span
      | ID {{ c.id_doutor }} · {{ c.email || 'sem e-mail' }} ·&nbsp;
      template(v-if="c.cpf") CPF {{ c.cpf | cpf }}
      template(v-else) sem CPF
    span usuário {{ c.status_usuario }} · cadastro {{ c.status_cadastro || 'sem cadastro' }}
    small.impedimento(v-if="c.permite_vinculo === false") {{ c.impedimento }}
  .manual
    button.alternar(type="button" @click="manual = !manual") {{ manual ? 'Fechar a busca' : 'Buscar outro supporter' }}
    Supporter(v-if="manual" :cb="escolherManual")
    p.msg.ok(v-if="value && value.manual") Escolhido pela busca: {{ value.nome }} (ID {{ value.id_doutor }}). O backend confere o cadastro ao vincular.
</template>

<script>
import Supporter from "@/views/admin/components/Supporter";

// Escolha do supporter para um login V.texp (sc-9881): os candidatos da sugestão, com o
// impedimento de quem não pode ser vinculado, e a busca manual do Supporter.vue para quando a
// sugestão não traz ninguém ou o operador sabe o nome certo. v-model com o candidato escolhido.
export default {
  name: "CandidatosSupporter",
  components: { Supporter },
  props: {
    candidatos: { type: Array, default: () => [] },
    value: { type: Object, default: null },
  },
  data() {
    return { manual: this.candidatos.length === 0 };
  },
  methods: {
    escolhidoE(c) { return !!this.value && this.value.id_doutor === c.id_doutor },
    escolherManual(s) {
      if (!s) return this.$emit("input", null)
      this.$emit("input", { id_doutor: s.id, nome: s.nome, email: s.email, cpf: s.cpf, status_usuario: s.status_usuario, permite_vinculo: null, impedimento: null, manual: true })
    },
  },
};
</script>

<style lang="sass" scoped>
@use "sass:color"
@use "@/assets/scss/vars.scss" as *
.candidatos-supporter
  label
    @include label
    display: block
  small
    display: block
    color: $gray-5
    font-size: 12px
    line-height: 1.45
    margin-top: 4px
  .candidato
    display: flex
    flex-direction: column
    gap: 2px
    width: 100%
    text-align: left
    background: white
    border: 1.6px solid $white-6
    border-radius: 8px
    padding: 8px 12px
    margin-top: 6px
    cursor: pointer
    font: inherit
    color: $font-color
    &:hover
      border-color: $purple
      background: rgba($purple, .08)
    &.sel
      border-color: $green-6
      background: $green-3
    &.impedido
      border-style: dashed
    b
      font-size: 15px
    span
      font-size: 13px
    .impedimento
      margin: 2px 0 0
      color: color.adjust($orange-1, $lightness: -25%)
  .manual
    margin-top: 10px
  .alternar
    background: none
    border: none
    padding: 0
    color: $purple
    font: inherit
    font-size: 13px
    cursor: pointer
    text-decoration: underline
  .msg
    margin: 8px 0 0
    font-size: 13px
    line-height: 1.45
    padding: 8px 10px
    border-radius: 8px
    &.ok
      background: $green-3
      color: $green-6
    &.vazio
      background: $white-8
      color: $gray-5
</style>
